(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-product-showcase-v1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('st-product-showcase-v1')) {
    class STProductShowcaseV1 extends HTMLElement {
      connectedCallback() {
        this.initializeWhenReady();
      }

      disconnectedCallback() {
        this.destroyMobileSwiper();
        this.unbindDescriptionExpanders();
        this.cancelAccordionAnimations();
        this.unbindFloatingAtcObserver();
        this.unbindAppointmentTriggers();
        this.unbindReviewsDrawer();
        this.unbindInfoDrawers();
        this.unbindImageLightbox();
      }

      initializeWhenReady(attempt = 0) {
        if (this.dataset.initialized === 'true') return;

        if (
          typeof window.Swiper !== 'function' &&
          attempt < 120
        ) {
          window.setTimeout(
            () => this.initializeWhenReady(attempt + 1),
            50
          );

          return;
        }

        this.initializeMobileGallery();
        this.bindVariantThumbnails();
        this.bindDescriptionExpanders();
        this.bindAccordions();
        this.bindFloatingAtcObserver();
        this.bindAppointmentTriggers();
        this.bindReviewsDrawer();
        this.bindInfoDrawers();
        this.bindImageLightbox();

        this.dataset.initialized = 'true';
      }

      initializeMobileGallery() {
        const slider = this.querySelector(
          '[data-mobile-gallery]'
        );

        if (
          !slider ||
          typeof window.Swiper !== 'function'
        ) {
          return;
        }

        const options = {
          slidesPerView: 1,
          speed: 500,
          loop: false,
          watchOverflow: true,
          observer: true,
          observeParents: true
        };

        const previousButton = this.querySelector(
          '[data-mobile-previous]'
        );

        const nextButton = this.querySelector(
          '[data-mobile-next]'
        );

        const pagination = this.querySelector(
          '[data-mobile-pagination]'
        );

        if (previousButton && nextButton) {
          options.navigation = {
            prevEl: previousButton,
            nextEl: nextButton
          };
        }

        if (pagination) {
          options.pagination = {
            el: pagination,
            clickable: true
          };
        }

        this.mobileSwiper = new window.Swiper(
          slider,
          options
        );

        const initialMediaId =
          this.dataset.initialMediaId;

        if (initialMediaId) {
          this.goToMobileMedia(initialMediaId, 0);
        }
      }

      destroyMobileSwiper() {
        if (
          this.mobileSwiper &&
          typeof this.mobileSwiper.destroy === 'function'
        ) {
          this.mobileSwiper.destroy(true, true);
          this.mobileSwiper = null;
        }
      }

      goToMobileMedia(mediaId, speed = 400) {
        if (!mediaId || !this.mobileSwiper) return;

        const slides = Array.from(
          this.querySelectorAll(
            '[data-mobile-media-id]'
          )
        );

        const targetIndex = slides.findIndex(
          (slide) =>
            slide.dataset.mobileMediaId === mediaId
        );

        if (targetIndex >= 0) {
          this.mobileSwiper.slideTo(
            targetIndex,
            speed
          );
        }
      }

      bindVariantThumbnails() {
        const thumbnails = this.querySelectorAll(
          '[data-variant-thumbnail]'
        );

        if (!thumbnails.length) return;

        const variantInputs = this.querySelectorAll(
          '[data-variant-input]'
        );

        const floatingVariantInput = this.querySelector(
          '[data-floating-variant-input]'
        );

        const variantName = this.querySelector(
          '[data-variant-name]'
        );

        const prices = this.querySelectorAll(
          '[data-product-price]'
        );

        const comparePrices = this.querySelectorAll(
          '[data-product-compare-price]'
        );

        const atcPrices = this.querySelectorAll(
          '[data-atc-price]'
        );

        const atcButtons = this.querySelectorAll(
          '[data-atc-button]'
        );

        const atcTexts = this.querySelectorAll(
          '[data-atc-text]'
        );

        const floatingButton = this.querySelector(
          '[data-floating-atc-button]'
        );

        const floatingText = this.querySelector(
          '[data-floating-atc-text]'
        );

        const floatingPrice = this.querySelector(
          '[data-floating-product-price]'
        );

        thumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => {
            const variantId =
              thumbnail.dataset.variantId;

            const available =
              thumbnail.dataset.variantAvailable === 'true';

            const featuredMediaId =
              thumbnail.dataset.featuredMediaId;

            thumbnails.forEach((item) => {
              const isActive = item === thumbnail;

              item.classList.toggle(
                'is-active',
                isActive
              );

              item.setAttribute(
                'aria-pressed',
                isActive ? 'true' : 'false'
              );
            });

            variantInputs.forEach((input) => {
              input.value = variantId;

              input.dispatchEvent(
                new Event('change', {
                  bubbles: true
                })
              );
            });

            if (floatingVariantInput) {
              floatingVariantInput.value = variantId;
            }

            if (variantName) {
              variantName.textContent =
                thumbnail.dataset.variantName || '';
            }

            prices.forEach((price) => {
              price.textContent =
                thumbnail.dataset.variantPrice || '';
            });

            comparePrices.forEach((comparePrice) => {
              const showComparePrice =
                thumbnail.dataset.showComparePrice === 'true';

              comparePrice.textContent =
                thumbnail.dataset.variantComparePrice || '';

              comparePrice.hidden =
                !showComparePrice;
            });

            atcPrices.forEach((price) => {
              price.textContent =
                thumbnail.dataset.variantPrice || '';
            });

            atcButtons.forEach((button) => {
              button.disabled = !available;
            });

            atcTexts.forEach((text) => {
              text.textContent =
                available ? 'Add to cart' : 'Sold out';
            });

            if (floatingButton) {
              floatingButton.disabled = !available;
            }

            if (floatingText) {
              floatingText.textContent =
                available ? 'Add to cart' : 'Sold out';
            }

            if (floatingPrice) {
              floatingPrice.textContent =
                thumbnail.dataset.variantPrice || '';
            }

            this.goToMobileMedia(
              featuredMediaId
            );

            if (variantId) {
              const url = new URL(
                window.location.href
              );

              url.searchParams.set(
                'variant',
                variantId
              );

              window.history.replaceState(
                {},
                '',
                url.toString()
              );
            }
          });
        });
      }

      bindDescriptionExpanders() {
        this.descriptionExpanders = Array.from(
          this.querySelectorAll('[data-description-expandable]')
        );

        if (!this.descriptionExpanders.length) return;

        this.descriptionMediaQuery = window.matchMedia(
          '(max-width: 749px)'
        );

        this.updateDescriptionExpanders = () => {
          const isMobile = this.descriptionMediaQuery.matches;

          this.descriptionExpanders.forEach((description) => {
            const enabled = isMobile
              ? description.dataset.readMoreMobile === 'true'
              : description.dataset.readMoreDesktop === 'true';

            const button = description.querySelector(
              '[data-description-read-more]'
            );

            let isExpanded =
              description.dataset.descriptionExpanded === 'true';

            if (!enabled) {
              isExpanded = false;
              description.dataset.descriptionExpanded = 'false';
            }

            description.classList.toggle(
              'is-collapsed',
              enabled && !isExpanded
            );

            description.classList.toggle(
              'is-expanded',
              enabled && isExpanded
            );

            if (button) {
              button.setAttribute(
                'aria-expanded',
                isExpanded ? 'true' : 'false'
              );

              button.textContent = isExpanded
                ? button.dataset.readLessLabel || 'Read less'
                : button.dataset.readMoreLabel || 'Read more';
            }
          });
        };

        this.handleDescriptionReadMore = (event) => {
          const button = event.currentTarget;
          const description = button.closest(
            '[data-description-expandable]'
          );

          if (!description) return;

          const isExpanded =
            description.dataset.descriptionExpanded === 'true';

          description.dataset.descriptionExpanded = isExpanded
            ? 'false'
            : 'true';

          this.updateDescriptionExpanders();
        };

        this.descriptionExpanders.forEach((description) => {
          const button = description.querySelector(
            '[data-description-read-more]'
          );

          button?.addEventListener(
            'click',
            this.handleDescriptionReadMore
          );
        });

        if (
          typeof this.descriptionMediaQuery.addEventListener ===
          'function'
        ) {
          this.descriptionMediaQuery.addEventListener(
            'change',
            this.updateDescriptionExpanders
          );
        } else {
          this.descriptionMediaQuery.addListener(
            this.updateDescriptionExpanders
          );
        }

        this.updateDescriptionExpanders();
      }

      unbindDescriptionExpanders() {
        if (
          this.descriptionExpanders &&
          this.handleDescriptionReadMore
        ) {
          this.descriptionExpanders.forEach((description) => {
            const button = description.querySelector(
              '[data-description-read-more]'
            );

            button?.removeEventListener(
              'click',
              this.handleDescriptionReadMore
            );
          });
        }

        if (
          this.descriptionMediaQuery &&
          this.updateDescriptionExpanders
        ) {
          if (
            typeof this.descriptionMediaQuery.removeEventListener ===
            'function'
          ) {
            this.descriptionMediaQuery.removeEventListener(
              'change',
              this.updateDescriptionExpanders
            );
          } else {
            this.descriptionMediaQuery.removeListener(
              this.updateDescriptionExpanders
            );
          }
        }

        this.descriptionExpanders = null;
        this.descriptionMediaQuery = null;
        this.updateDescriptionExpanders = null;
        this.handleDescriptionReadMore = null;
      }

      bindAccordions() {
        const accordions = this.querySelectorAll(
          '.st-product-showcase-v1__accordion'
        );

        accordions.forEach((accordion) => {
          if (
            accordion.dataset.accordionBound === 'true'
          ) {
            return;
          }

          const summary = accordion.querySelector(
            ':scope > summary'
          );

          const motion = accordion.querySelector(
            ':scope > .st-product-showcase-v1__accordion-motion'
          );

          if (!summary || !motion) return;

          accordion.dataset.accordionBound = 'true';

          summary.setAttribute(
            'aria-expanded',
            accordion.open ? 'true' : 'false'
          );

          summary.addEventListener('click', (event) => {
            event.preventDefault();

            if (
              accordion.dataset.accordionAnimating ===
              'true'
            ) {
              return;
            }

            this.animateAccordion(
              accordion,
              summary,
              motion,
              !accordion.open
            );
          });
        });
      }

      getAccordionDuration(accordion) {
        const durationValue = window
          .getComputedStyle(accordion)
          .getPropertyValue(
            '--st-psv1-accordion-duration'
          )
          .trim();

        const duration = Number.parseFloat(
          durationValue
        );

        return Number.isFinite(duration)
          ? duration
          : 300;
      }

      animateAccordion(
        accordion,
        summary,
        motion,
        shouldOpen
      ) {
        const duration = this.getAccordionDuration(
          accordion
        );

        const reduceMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        const finishAnimation = () => {
          if (
            accordion.dataset.accordionAnimating !==
            'true'
          ) {
            return;
          }

          if (accordion._stAccordionTimer) {
            window.clearTimeout(
              accordion._stAccordionTimer
            );
          }

          motion.removeEventListener(
            'transitionend',
            accordion._stAccordionTransitionEnd
          );

          if (!shouldOpen) {
            accordion.open = false;
          }

          summary.setAttribute(
            'aria-expanded',
            shouldOpen ? 'true' : 'false'
          );

          accordion.classList.remove(
            'is-opening',
            'is-closing'
          );

          delete accordion.dataset.accordionAnimating;

          motion.style.removeProperty('height');
          motion.style.removeProperty('opacity');
          motion.style.removeProperty('transition');
          motion.style.removeProperty('will-change');

          accordion._stAccordionFinish = null;
          accordion._stAccordionTimer = null;
          accordion._stAccordionTransitionEnd = null;
        };

        accordion.dataset.accordionAnimating = 'true';
        accordion.classList.toggle(
          'is-opening',
          shouldOpen
        );
        accordion.classList.toggle(
          'is-closing',
          !shouldOpen
        );

        summary.setAttribute(
          'aria-expanded',
          shouldOpen ? 'true' : 'false'
        );

        if (shouldOpen) {
          accordion.open = true;
        }

        accordion._stAccordionFinish =
          finishAnimation;

        if (reduceMotion || duration <= 0) {
          finishAnimation();
          return;
        }

        motion.style.willChange = 'height, opacity';
        motion.style.transition = 'none';
        motion.style.height = shouldOpen
          ? '0px'
          : `${motion.scrollHeight}px`;
        motion.style.opacity = shouldOpen ? '0' : '1';

        motion.offsetHeight;

        const opacityDuration = Math.min(
          duration,
          250
        );

        motion.style.transition = [
          `height ${duration}ms cubic-bezier(0.4, 0, 0.2, 1)`,
          `opacity ${opacityDuration}ms ease`
        ].join(', ');

        accordion._stAccordionTransitionEnd = (
          event
        ) => {
          if (
            event.target !== motion ||
            event.propertyName !== 'height'
          ) {
            return;
          }

          finishAnimation();
        };

        motion.addEventListener(
          'transitionend',
          accordion._stAccordionTransitionEnd
        );

        accordion._stAccordionTimer =
          window.setTimeout(
            finishAnimation,
            duration + 100
          );

        window.requestAnimationFrame(() => {
          motion.style.height = shouldOpen
            ? `${motion.scrollHeight}px`
            : '0px';
          motion.style.opacity = shouldOpen ? '1' : '0';
        });
      }

      cancelAccordionAnimations() {
        this.querySelectorAll(
          '.st-product-showcase-v1__accordion'
        ).forEach((accordion) => {
          if (
            typeof accordion._stAccordionFinish ===
            'function'
          ) {
            accordion._stAccordionFinish();
          }
        });
      }

      bindFloatingAtcObserver() {
        this.mainAtcBlock = this.querySelector(
          '.st-product-showcase-v1__buy-buttons-block'
        );

        this.floatingAtc = this.querySelector(
          '.st-product-showcase-v1__floating-atc'
        );

        if (!this.mainAtcBlock || !this.floatingAtc) {
          return;
        }

        const updateFloatingAtc = (mainAtcVisible) => {
          const isMobile = window.matchMedia(
            '(max-width: 989px)'
          ).matches;

          const shouldShow = isMobile && !mainAtcVisible;

          this.floatingAtc.classList.toggle(
            'is-visible',
            shouldShow
          );

          this.floatingAtc.setAttribute(
            'aria-hidden',
            shouldShow ? 'false' : 'true'
          );
        };

        this.floatingAtcObserver = new IntersectionObserver(
          (entries) => {
            updateFloatingAtc(entries[0].isIntersecting);
          },
          {
            root: null,
            threshold: 0.01
          }
        );

        this.floatingAtcObserver.observe(
          this.mainAtcBlock
        );

        this.handleFloatingAtcResize = () => {
          const rect = this.mainAtcBlock.getBoundingClientRect();
          const mainAtcVisible =
            rect.bottom > 0 &&
            rect.top < window.innerHeight;

          updateFloatingAtc(mainAtcVisible);
        };

        window.addEventListener(
          'resize',
          this.handleFloatingAtcResize
        );

        this.handleFloatingAtcResize();
      }

      unbindFloatingAtcObserver() {
        if (this.floatingAtcObserver) {
          this.floatingAtcObserver.disconnect();
          this.floatingAtcObserver = null;
        }

        if (this.handleFloatingAtcResize) {
          window.removeEventListener(
            'resize',
            this.handleFloatingAtcResize
          );

          this.handleFloatingAtcResize = null;
        }
      }

      loadCalendlyAssets() {
        if (!document.querySelector('link[data-st-calendly-css]')) {
          const stylesheet = document.createElement('link');
          stylesheet.rel = 'stylesheet';
          stylesheet.href =
            'https://assets.calendly.com/assets/external/widget.css';
          stylesheet.dataset.stCalendlyCss = 'true';
          document.head.appendChild(stylesheet);
        }

        if (window.Calendly) {
          return Promise.resolve(window.Calendly);
        }

        if (window.stCalendlyLoadingPromise) {
          return window.stCalendlyLoadingPromise;
        }

        window.stCalendlyLoadingPromise = new Promise(
          (resolve, reject) => {
            const existingScript = document.querySelector(
              'script[data-st-calendly-script]'
            );

            if (existingScript) {
              existingScript.addEventListener(
                'load',
                () => resolve(window.Calendly),
                { once: true }
              );

              existingScript.addEventListener(
                'error',
                reject,
                { once: true }
              );

              return;
            }

            const script = document.createElement('script');
            script.src =
              'https://assets.calendly.com/assets/external/widget.js';
            script.async = true;
            script.dataset.stCalendlyScript = 'true';

            script.addEventListener(
              'load',
              () => resolve(window.Calendly),
              { once: true }
            );

            script.addEventListener(
              'error',
              reject,
              { once: true }
            );

            document.body.appendChild(script);
          }
        );

        return window.stCalendlyLoadingPromise;
      }

      extractCalendlyUrl(embedCode) {
        if (!embedCode) return '';

        const patterns = [
          /initPopupWidget\s*\(\s*\{[\s\S]*?url\s*:\s*['"]([^'"]+)['"]/i,
          /initBadgeWidget\s*\(\s*\{[\s\S]*?url\s*:\s*['"]([^'"]+)['"]/i,
          /data-url\s*=\s*['"]([^'"]*calendly\.com[^'"]*)['"]/i,
          /href\s*=\s*['"]([^'"]*calendly\.com[^'"]*)['"]/i,
          /src\s*=\s*['"]([^'"]*calendly\.com[^'"]*)['"]/i,
          /(https?:\/\/calendly\.com\/[A-Za-z0-9_?&=\-/.%]+)/i
        ];

        for (const pattern of patterns) {
          const match = embedCode.match(pattern);

          if (match && match[1]) {
            return match[1].replace(/&amp;/g, '&');
          }
        }

        return '';
      }

      createAppointmentModal() {
        if (this.appointmentModal) {
          return this.appointmentModal;
        }

        const modal = document.createElement('div');
        modal.className = 'st-product-showcase-v1__appointment-modal';
        modal.hidden = true;
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-label', 'Appointment scheduling');

        modal.innerHTML = `
          <div class="st-product-showcase-v1__appointment-modal-dialog">
            <button
              type="button"
              class="st-product-showcase-v1__appointment-modal-close"
              data-appointment-modal-close
              aria-label="Close appointment popup"
            >
              &times;
            </button>
            <div class="st-product-showcase-v1__appointment-modal-content" data-appointment-modal-content></div>
          </div>
        `;

        document.body.appendChild(modal);

        this.appointmentModal = modal;
        this.appointmentModalContent = modal.querySelector(
          '[data-appointment-modal-content]'
        );
        this.appointmentModalClose = modal.querySelector(
          '[data-appointment-modal-close]'
        );

        this.handleAppointmentModalClose = () => {
          this.closeAppointmentModal();
        };

        this.handleAppointmentModalOverlay = (event) => {
          if (event.target === modal) {
            this.closeAppointmentModal();
          }
        };

        this.handleAppointmentModalEscape = (event) => {
          if (event.key === 'Escape' && !modal.hidden) {
            this.closeAppointmentModal();
          }
        };

        this.appointmentModalClose.addEventListener(
          'click',
          this.handleAppointmentModalClose
        );
        modal.addEventListener(
          'click',
          this.handleAppointmentModalOverlay
        );
        document.addEventListener(
          'keydown',
          this.handleAppointmentModalEscape
        );

        return modal;
      }

      executeEmbeddedScripts(container) {
        const scripts = Array.from(
          container.querySelectorAll('script')
        );

        scripts.forEach((oldScript) => {
          const newScript = document.createElement('script');

          Array.from(oldScript.attributes).forEach((attribute) => {
            newScript.setAttribute(attribute.name, attribute.value);
          });

          newScript.textContent = oldScript.textContent;
          oldScript.replaceWith(newScript);
        });
      }

      openGenericEmbedPopup(template) {
        const modal = this.createAppointmentModal();

        this.appointmentModalContent.innerHTML = template.innerHTML;
        this.executeEmbeddedScripts(this.appointmentModalContent);

        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';

        window.setTimeout(() => {
          this.appointmentModalClose?.focus();
        }, 0);
      }

      closeAppointmentModal() {
        if (!this.appointmentModal) return;

        this.appointmentModal.hidden = true;

        if (this.appointmentModalContent) {
          this.appointmentModalContent.innerHTML = '';
        }

        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';

        if (this.activeAppointmentTrigger) {
          this.activeAppointmentTrigger.focus();
        }
      }

      bindAppointmentTriggers() {
        this.appointmentTriggers = Array.from(
          this.querySelectorAll('[data-appointment-trigger]')
        );

        if (!this.appointmentTriggers.length) {
          return;
        }

        /* Close Calendly when the dark area outside the popup is clicked. */
        this.handleCalendlyOverlayClick = (event) => {
          const overlay = event.target.closest('.calendly-overlay');

          if (!overlay || event.target !== overlay) {
            return;
          }

          if (
            window.Calendly &&
            typeof window.Calendly.closePopupWidget === 'function'
          ) {
            window.Calendly.closePopupWidget();
            return;
          }

          const closeButton = overlay.querySelector(
            '.calendly-popup-close'
          );

          if (closeButton) {
            closeButton.click();
          }
        };

        document.addEventListener(
          'click',
          this.handleCalendlyOverlayClick,
          true
        );

        this.handleAppointmentClick = async (event) => {
          const trigger = event.currentTarget;
          const mode = trigger.dataset.appointmentMode || 'url_popup';
          const block = trigger.closest(
            '.st-product-showcase-v1__appointment-block'
          );
          const template = block?.querySelector(
            '[data-appointment-embed-template]'
          );

          event.preventDefault();
          this.activeAppointmentTrigger = trigger;

          let appointmentUrl =
            trigger.dataset.appointmentUrl || '';

          if (mode === 'embed_code' && template) {
            appointmentUrl = this.extractCalendlyUrl(
              template.innerHTML
            );
          }

          if (appointmentUrl) {
            try {
              const calendly = await this.loadCalendlyAssets();

              if (
                calendly &&
                typeof calendly.initPopupWidget === 'function'
              ) {
                calendly.initPopupWidget({
                  url: appointmentUrl
                });
                return;
              }
            } catch (error) {
              console.warn(
                'Calendly popup could not be loaded.',
                error
              );
            }
          }

          if (mode === 'embed_code' && template) {
            this.openGenericEmbedPopup(template);
            return;
          }

          if (appointmentUrl) {
            window.location.href = appointmentUrl;
          }
        };

        this.appointmentTriggers.forEach((trigger) => {
          trigger.addEventListener(
            'click',
            this.handleAppointmentClick
          );
        });
      }

      unbindAppointmentTriggers() {
        if (
          this.appointmentTriggers &&
          this.handleAppointmentClick
        ) {
          this.appointmentTriggers.forEach((trigger) => {
            trigger.removeEventListener(
              'click',
              this.handleAppointmentClick
            );
          });
        }

        if (this.appointmentModalClose) {
          this.appointmentModalClose.removeEventListener(
            'click',
            this.handleAppointmentModalClose
          );
        }

        if (this.appointmentModal) {
          this.appointmentModal.removeEventListener(
            'click',
            this.handleAppointmentModalOverlay
          );
          this.appointmentModal.remove();
        }

        if (this.handleAppointmentModalEscape) {
          document.removeEventListener(
            'keydown',
            this.handleAppointmentModalEscape
          );
        }

        if (this.handleCalendlyOverlayClick) {
          document.removeEventListener(
            'click',
            this.handleCalendlyOverlayClick,
            true
          );
        }

        this.appointmentTriggers = null;
        this.handleAppointmentClick = null;
        this.appointmentModal = null;
        this.appointmentModalContent = null;
        this.appointmentModalClose = null;
      }


      bindImageLightbox() {
        this.imageLightboxTriggers = Array.from(
          this.querySelectorAll('[data-image-lightbox-trigger]')
        );

        this.imageLightbox = this.querySelector(
          '[data-image-lightbox]'
        );

        this.imageLightboxSlider = this.querySelector(
          '[data-image-lightbox-swiper]'
        );

        this.imageLightboxClose = this.querySelector(
          '[data-image-lightbox-close]'
        );

        this.imageLightboxPrevious = this.querySelector(
          '[data-image-lightbox-previous]'
        );

        this.imageLightboxNext = this.querySelector(
          '[data-image-lightbox-next]'
        );

        this.imageLightboxCounter = this.querySelector(
          '[data-image-lightbox-counter]'
        );

        this.imageLightboxZoomEnabled =
          this.imageLightbox?.dataset.imageLightboxZoomEnabled === 'true';

        if (
          !this.imageLightboxTriggers.length ||
          !this.imageLightbox ||
          !this.imageLightboxSlider ||
          typeof window.Swiper !== 'function'
        ) {
          return;
        }

        const slides = Array.from(
          this.querySelectorAll('[data-lightbox-slide-media-id]')
        );

        const swiperOptions = {
          slidesPerView: 1,
          speed: 420,
          loop: false,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          resistanceRatio: 0.75,
          on: {
            init: () => this.updateImageLightboxCounter(),
            slideChange: () => {
              this.updateImageLightboxCounter();
              this.pauseImageLightboxVideos();

              window.requestAnimationFrame(() => {
                this.syncImageLightboxVideoPlayback();
              });

              if (this.imageLightboxZoomEnabled) {
                window.requestAnimationFrame(() => {
                  this.resetImageLightboxZoom();
                });
              }
            }
          }
        };

        if (this.imageLightboxZoomEnabled) {
          swiperOptions.zoom = {
            enabled: true,
            maxRatio: 3,
            minRatio: 1,
            toggle: true
          };
        }

        this.imageLightboxSwiper = new window.Swiper(
          this.imageLightboxSlider,
          swiperOptions
        );

        if (this.imageLightboxZoomEnabled) {
          this.imageLightboxZoomImages = Array.from(
            this.imageLightbox.querySelectorAll(
              '.st-product-showcase-v1__lightbox-image'
            )
          );

          this.handleImageLightboxZoomClick = (event) => {
            const isDesktopPointer = window.matchMedia(
              '(hover: hover) and (pointer: fine)'
            ).matches;

            if (
              !isDesktopPointer ||
              !this.imageLightboxSwiper?.zoom
            ) {
              return;
            }

            const activeSlide = event.currentTarget.closest(
              '.swiper-slide-active'
            );

            if (!activeSlide) return;

            event.preventDefault();
            event.stopPropagation();
            this.imageLightboxSwiper.zoom.toggle(event);
          };

          this.imageLightboxZoomImages.forEach((image) => {
            image.addEventListener(
              'click',
              this.handleImageLightboxZoomClick
            );
          });
        }

        this.openImageLightbox = (trigger) => {
          const mediaId = trigger.dataset.lightboxMediaId;
          const targetIndex = slides.findIndex(
            (slide) => slide.dataset.lightboxSlideMediaId === mediaId
          );

          this.activeImageLightboxTrigger = trigger;

          if (this.imageLightboxCloseTimer) {
            window.clearTimeout(this.imageLightboxCloseTimer);
            this.imageLightboxCloseTimer = null;
          }

          this.imageLightbox.hidden = false;
          this.imageLightbox.setAttribute('aria-hidden', 'false');

          if (!this.imageLightboxScrollLocked) {
            this.imageLightboxPreviousDocumentOverflow =
              document.documentElement.style.overflow;
            this.imageLightboxPreviousBodyOverflow =
              document.body.style.overflow;

            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
            this.imageLightboxScrollLocked = true;
          }

          window.requestAnimationFrame(() => {
            this.imageLightbox.classList.add('is-open');
            this.imageLightboxSwiper.update();

            if (targetIndex >= 0) {
              this.imageLightboxSwiper.slideTo(targetIndex, 0);
            }

            this.updateImageLightboxCounter();
            this.syncImageLightboxVideoPlayback();

            window.setTimeout(() => {
              this.imageLightboxClose?.focus();
            }, 30);
          });
        };

        this.closeImageLightbox = () => {
          if (!this.imageLightbox) return;

          this.resetImageLightboxZoom();
          this.pauseImageLightboxVideos();
          this.imageLightbox.classList.remove('is-open');
          this.imageLightbox.setAttribute('aria-hidden', 'true');

          if (this.imageLightboxScrollLocked) {
            document.documentElement.style.overflow =
              this.imageLightboxPreviousDocumentOverflow || '';
            document.body.style.overflow =
              this.imageLightboxPreviousBodyOverflow || '';

            this.imageLightboxScrollLocked = false;
            this.imageLightboxPreviousDocumentOverflow = '';
            this.imageLightboxPreviousBodyOverflow = '';
          }

          if (this.imageLightboxCloseTimer) {
            window.clearTimeout(this.imageLightboxCloseTimer);
          }

          this.imageLightboxCloseTimer = window.setTimeout(() => {
            if (!this.imageLightbox) return;

            this.imageLightbox.hidden = true;
            this.activeImageLightboxTrigger?.focus();
            this.activeImageLightboxTrigger = null;
            this.imageLightboxCloseTimer = null;
          }, 230);
        };

        this.handleImageLightboxTriggerClick = (event) => {
          event.preventDefault();
          this.openImageLightbox(event.currentTarget);
        };

        this.handleImageLightboxOverlayClick = (event) => {
          if (
            event.target.closest(
              '.st-product-showcase-v1__lightbox-image, .st-product-showcase-v1__lightbox-video, .st-product-showcase-v1__lightbox-close, .st-product-showcase-v1__lightbox-arrow'
            )
          ) {
            return;
          }

          this.closeImageLightbox();
        };

        this.handleImageLightboxKeydown = (event) => {
          if (!this.imageLightbox.classList.contains('is-open')) return;

          if (event.key === 'Escape') {
            event.preventDefault();
            this.closeImageLightbox();
            return;
          }

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.resetImageLightboxZoom();
            this.imageLightboxSwiper?.slidePrev();
            return;
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.resetImageLightboxZoom();
            this.imageLightboxSwiper?.slideNext();
          }
        };

        this.handleImageLightboxPrevious = (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.resetImageLightboxZoom();
          this.imageLightboxSwiper?.slidePrev();
        };

        this.handleImageLightboxNext = (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.resetImageLightboxZoom();
          this.imageLightboxSwiper?.slideNext();
        };

        this.imageLightboxPrevious?.addEventListener(
          'click',
          this.handleImageLightboxPrevious
        );

        this.imageLightboxNext?.addEventListener(
          'click',
          this.handleImageLightboxNext
        );

        this.imageLightboxTriggers.forEach((trigger) => {
          trigger.addEventListener(
            'click',
            this.handleImageLightboxTriggerClick
          );
        });

        this.imageLightboxClose?.addEventListener(
          'click',
          this.closeImageLightbox
        );

        this.imageLightbox.addEventListener(
          'click',
          this.handleImageLightboxOverlayClick
        );

        document.addEventListener(
          'keydown',
          this.handleImageLightboxKeydown
        );
      }

      pauseImageLightboxVideos() {
        if (!this.imageLightbox) return;

        this.imageLightbox
          .querySelectorAll('video')
          .forEach((video) => {
            try {
              video.pause();
              video.currentTime = 0;
            } catch (error) {
              // Optional cleanup only.
            }
          });

        this.imageLightbox
          .querySelectorAll('[data-lightbox-external-video]')
          .forEach((iframe) => {
            iframe.removeAttribute('src');
          });
      }

      syncImageLightboxVideoPlayback() {
        if (
          !this.imageLightbox ||
          !this.imageLightbox.classList.contains('is-open')
        ) {
          return;
        }

        const activeSlide = this.imageLightbox.querySelector(
          '.swiper-slide-active'
        );

        if (!activeSlide) return;

        const activeVideo = activeSlide.querySelector('video');
        const activeExternalVideo = activeSlide.querySelector(
          '[data-lightbox-external-video]'
        );

        this.imageLightbox.querySelectorAll('video').forEach((video) => {
          if (video === activeVideo) return;

          try {
            video.pause();
            video.currentTime = 0;
          } catch (error) {
            // Optional cleanup only.
          }
        });

        this.imageLightbox
          .querySelectorAll('[data-lightbox-external-video]')
          .forEach((iframe) => {
            if (iframe !== activeExternalVideo) {
              iframe.removeAttribute('src');
            }
          });

        if (
          activeVideo &&
          activeVideo.paused !== false &&
          typeof activeVideo.play === 'function'
        ) {
          try {
            const playPromise = activeVideo.play();

            if (
              playPromise &&
              typeof playPromise.catch === 'function'
            ) {
              playPromise.catch((error) => {
                const activeVideoSlide = activeVideo.closest?.(
                  '.swiper-slide-active'
                );

                if (
                  error?.name !== 'NotAllowedError' ||
                  !activeVideoSlide ||
                  !this.imageLightbox?.classList.contains('is-open')
                ) {
                  return;
                }

                activeVideo.muted = true;

                const mutedPlayPromise = activeVideo.play();

                if (
                  mutedPlayPromise &&
                  typeof mutedPlayPromise.catch === 'function'
                ) {
                  mutedPlayPromise.catch(() => {});
                }
              });
            }
          } catch (error) {
            // Native controls remain available if playback is unavailable.
          }
        }

        if (
          activeExternalVideo &&
          activeExternalVideo.dataset.src &&
          !activeExternalVideo.getAttribute('src')
        ) {
          activeExternalVideo.setAttribute(
            'src',
            activeExternalVideo.dataset.src
          );
        }
      }

      resetImageLightboxZoom() {
        if (
          !this.imageLightboxZoomEnabled ||
          !this.imageLightboxSwiper ||
          !this.imageLightboxSwiper.zoom ||
          typeof this.imageLightboxSwiper.zoom.out !== 'function'
        ) {
          return;
        }

        const zoomedSlide = this.imageLightboxSlider?.querySelector(
          '.swiper-slide-zoomed'
        );

        /*
         * Swiper's zoom.out() expects its internal active zoom elements to
         * already exist. Calling it before a slide has actually been zoomed
         * causes an undefined querySelector error and stops the popup code.
         */
        if (!zoomedSlide) {
          return;
        }

        try {
          this.imageLightboxSwiper.zoom.out();
        } catch (error) {
          /*
           * Never allow an optional zoom reset to break the gallery popup.
           * If Swiper has already cleared its internal zoom references, just
           * remove the visual zoom state and continue.
           */
          zoomedSlide.classList.remove('swiper-slide-zoomed');

          const zoomContainer = zoomedSlide.querySelector(
            '.swiper-zoom-container'
          );

          if (zoomContainer) {
            zoomContainer.style.transform = '';
            zoomContainer.style.transitionDuration = '';
          }

          const image = zoomedSlide.querySelector(
            '.st-product-showcase-v1__lightbox-image'
          );

          if (image) {
            image.style.transform = '';
            image.style.transitionDuration = '';
          }
        }
      }

      updateImageLightboxCounter() {
        if (!this.imageLightboxCounter || !this.imageLightboxSwiper) {
          return;
        }

        const total = this.imageLightboxSwiper.slides.length;
        const current = this.imageLightboxSwiper.activeIndex + 1;

        this.imageLightboxCounter.textContent = `${current} / ${total}`;
      }

      unbindImageLightbox() {
        if (this.imageLightboxCloseTimer) {
          window.clearTimeout(this.imageLightboxCloseTimer);
          this.imageLightboxCloseTimer = null;
        }

        if (this.imageLightboxScrollLocked) {
          document.documentElement.style.overflow =
            this.imageLightboxPreviousDocumentOverflow || '';
          document.body.style.overflow =
            this.imageLightboxPreviousBodyOverflow || '';
          this.imageLightboxScrollLocked = false;
        }

        if (
          this.imageLightboxTriggers &&
          this.handleImageLightboxTriggerClick
        ) {
          this.imageLightboxTriggers.forEach((trigger) => {
            trigger.removeEventListener(
              'click',
              this.handleImageLightboxTriggerClick
            );
          });
        }

        if (
          this.imageLightboxPrevious &&
          this.handleImageLightboxPrevious
        ) {
          this.imageLightboxPrevious.removeEventListener(
            'click',
            this.handleImageLightboxPrevious
          );
        }

        if (
          this.imageLightboxNext &&
          this.handleImageLightboxNext
        ) {
          this.imageLightboxNext.removeEventListener(
            'click',
            this.handleImageLightboxNext
          );
        }

        if (this.imageLightboxClose && this.closeImageLightbox) {
          this.imageLightboxClose.removeEventListener(
            'click',
            this.closeImageLightbox
          );
        }

        if (
          this.imageLightbox &&
          this.handleImageLightboxOverlayClick
        ) {
          this.imageLightbox.removeEventListener(
            'click',
            this.handleImageLightboxOverlayClick
          );
        }

        if (this.handleImageLightboxKeydown) {
          document.removeEventListener(
            'keydown',
            this.handleImageLightboxKeydown
          );
        }

        if (
          this.imageLightboxZoomImages &&
          this.handleImageLightboxZoomClick
        ) {
          this.imageLightboxZoomImages.forEach((image) => {
            image.removeEventListener(
              'click',
              this.handleImageLightboxZoomClick
            );
          });
        }

        if (
          this.imageLightboxSwiper &&
          typeof this.imageLightboxSwiper.destroy === 'function'
        ) {
          this.imageLightboxSwiper.destroy(true, true);
        }

        this.imageLightboxSwiper = null;
        this.imageLightboxTriggers = null;
        this.imageLightbox = null;
        this.imageLightboxSlider = null;
        this.imageLightboxClose = null;
        this.imageLightboxPrevious = null;
        this.imageLightboxNext = null;
        this.imageLightboxCounter = null;
        this.imageLightboxZoomEnabled = false;
        this.imageLightboxZoomImages = null;
        this.handleImageLightboxZoomClick = null;
        this.openImageLightbox = null;
        this.closeImageLightbox = null;
        this.handleImageLightboxPrevious = null;
        this.handleImageLightboxNext = null;
        this.handleImageLightboxTriggerClick = null;
        this.handleImageLightboxOverlayClick = null;
        this.handleImageLightboxKeydown = null;
      }


      bindInfoDrawers() {
        this.infoDrawerTriggers = Array.from(
          this.querySelectorAll('[data-info-drawer-trigger]')
        );

        this.infoDrawerOverlay = this.querySelector(
          '[data-info-drawer-overlay]'
        );

        this.infoDrawerPanel = this.querySelector(
          '[data-info-drawer-panel]'
        );

        this.infoDrawerClose = this.querySelector(
          '[data-info-drawer-close]'
        );

        this.infoDrawerTitle = this.querySelector(
          '[data-info-drawer-title]'
        );

        this.infoDrawerContent = this.querySelector(
          '[data-info-drawer-content]'
        );

        if (
          !this.infoDrawerTriggers.length ||
          !this.infoDrawerOverlay ||
          !this.infoDrawerPanel ||
          !this.infoDrawerTitle ||
          !this.infoDrawerContent
        ) {
          return;
        }

        this.openInfoDrawer = (trigger) => {
          const block = trigger.closest(
            '.st-product-showcase-v1__info-drawer-block'
          );

          const template = block?.querySelector(
            '[data-info-drawer-template]'
          );

          const templateContent = template?.content.querySelector(
            '[data-info-drawer-template-content]'
          );

          if (!templateContent) return;

          this.activeInfoDrawerTrigger = trigger;
          this.infoDrawerTitle.textContent =
            templateContent.dataset.drawerTitle || '';

          this.infoDrawerContent.innerHTML = '';
          this.infoDrawerContent.appendChild(
            templateContent.cloneNode(true)
          );

          /*
           * Video elements are cloned from a <template>. Some browsers do
           * not reliably start an autoplaying video immediately after the
           * clone is inserted, so start any autoplay-enabled videos here.
           */
          this.infoDrawerContent
            .querySelectorAll('video[autoplay]')
            .forEach((video) => {
              const playPromise = video.play();

              if (
                playPromise &&
                typeof playPromise.catch === 'function'
              ) {
                playPromise.catch(() => {});
              }
            });

          this.infoDrawerTriggers.forEach((item) => {
            item.setAttribute(
              'aria-expanded',
              item === trigger ? 'true' : 'false'
            );
          });

          if (this.infoDrawerCloseTimer) {
            window.clearTimeout(this.infoDrawerCloseTimer);
            this.infoDrawerCloseTimer = null;
          }

          this.infoDrawerOverlay.hidden = false;

          if (!this.infoDrawerScrollLocked) {
            this.previousDocumentOverflow =
              document.documentElement.style.overflow;
            this.previousBodyOverflow =
              document.body.style.overflow;

            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
            this.infoDrawerScrollLocked = true;
          }

          window.requestAnimationFrame(() => {
            if (!this.infoDrawerOverlay) return;

            this.infoDrawerOverlay.classList.add('is-open');

            window.setTimeout(() => {
              this.infoDrawerClose?.focus();
            }, 50);
          });
        };

        this.closeInfoDrawer = () => {
          if (!this.infoDrawerOverlay) return;

          this.infoDrawerOverlay.classList.remove('is-open');

          this.infoDrawerTriggers.forEach((item) => {
            item.setAttribute('aria-expanded', 'false');
          });

          if (this.infoDrawerScrollLocked) {
            document.documentElement.style.overflow =
              this.previousDocumentOverflow || '';
            document.body.style.overflow =
              this.previousBodyOverflow || '';

            this.infoDrawerScrollLocked = false;
            this.previousDocumentOverflow = '';
            this.previousBodyOverflow = '';
          }

          if (this.infoDrawerCloseTimer) {
            window.clearTimeout(this.infoDrawerCloseTimer);
          }

          this.infoDrawerCloseTimer = window.setTimeout(() => {
            if (!this.infoDrawerOverlay) return;

            this.infoDrawerOverlay.hidden = true;
            this.infoDrawerContent.innerHTML = '';

            this.activeInfoDrawerTrigger?.focus();
            this.activeInfoDrawerTrigger = null;
            this.infoDrawerCloseTimer = null;
          }, 390);
        };

        this.handleInfoDrawerTriggerClick = (event) => {
          this.openInfoDrawer(event.currentTarget);
        };

        this.handleInfoDrawerOverlayClick = (event) => {
          if (event.target === this.infoDrawerOverlay) {
            this.closeInfoDrawer();
          }
        };

        this.handleInfoDrawerEscape = (event) => {
          if (
            event.key === 'Escape' &&
            this.infoDrawerOverlay.classList.contains('is-open')
          ) {
            this.closeInfoDrawer();
          }
        };

        this.infoDrawerTriggers.forEach((trigger) => {
          trigger.addEventListener(
            'click',
            this.handleInfoDrawerTriggerClick
          );
        });

        this.infoDrawerOverlay.addEventListener(
          'click',
          this.handleInfoDrawerOverlayClick
        );

        this.infoDrawerClose?.addEventListener(
          'click',
          this.closeInfoDrawer
        );

        document.addEventListener(
          'keydown',
          this.handleInfoDrawerEscape
        );
      }

      unbindInfoDrawers() {
        if (this.infoDrawerCloseTimer) {
          window.clearTimeout(this.infoDrawerCloseTimer);
          this.infoDrawerCloseTimer = null;
        }

        if (this.infoDrawerScrollLocked) {
          document.documentElement.style.overflow =
            this.previousDocumentOverflow || '';
          document.body.style.overflow =
            this.previousBodyOverflow || '';
          this.infoDrawerScrollLocked = false;
        }

        if (
          this.infoDrawerTriggers &&
          this.handleInfoDrawerTriggerClick
        ) {
          this.infoDrawerTriggers.forEach((trigger) => {
            trigger.removeEventListener(
              'click',
              this.handleInfoDrawerTriggerClick
            );
          });
        }

        if (
          this.infoDrawerOverlay &&
          this.handleInfoDrawerOverlayClick
        ) {
          this.infoDrawerOverlay.removeEventListener(
            'click',
            this.handleInfoDrawerOverlayClick
          );
        }

        if (this.infoDrawerClose && this.closeInfoDrawer) {
          this.infoDrawerClose.removeEventListener(
            'click',
            this.closeInfoDrawer
          );
        }

        if (this.handleInfoDrawerEscape) {
          document.removeEventListener(
            'keydown',
            this.handleInfoDrawerEscape
          );
        }

        this.infoDrawerTriggers = null;
        this.infoDrawerOverlay = null;
        this.infoDrawerPanel = null;
        this.infoDrawerClose = null;
        this.infoDrawerTitle = null;
        this.infoDrawerContent = null;
      }

      bindReviewsDrawer() {
        this.reviewTrigger = this.querySelector(
          '[data-reviews-trigger]'
        );

        this.reviewOverlay = document.querySelector(
          '.st-sidebar-reviews-block'
        );

        this.reviewDrawer = document.querySelector(
          '.st-sidebar-reviews-innerblock'
        );

        this.reviewCloseButton = document.querySelector(
          '.st-sidebar-reviews-close-icon'
        );

        if (
          !this.reviewTrigger ||
          !this.reviewOverlay ||
          !this.reviewDrawer
        ) {
          return;
        }

        this.openReviewsDrawer = () => {
          this.reviewOverlay.classList.add('active');
          this.reviewDrawer.classList.add('active');
          this.reviewTrigger.setAttribute(
            'aria-expanded',
            'true'
          );

          document.documentElement.style.overflow =
            'hidden';

          document.body.style.overflow =
            'hidden';
        };

        this.closeReviewsDrawer = () => {
          this.reviewOverlay.classList.remove('active');
          this.reviewDrawer.classList.remove('active');
          this.reviewTrigger.setAttribute(
            'aria-expanded',
            'false'
          );

          document.documentElement.style.overflow =
            '';

          document.body.style.overflow =
            '';
        };

        this.handleReviewTriggerKeydown = (
          event
        ) => {
          if (
            event.key === 'Enter' ||
            event.key === ' '
          ) {
            event.preventDefault();
            this.openReviewsDrawer();
          }
        };

        this.handleReviewOverlayClick = (
          event
        ) => {
          if (event.target === this.reviewOverlay) {
            this.closeReviewsDrawer();
          }
        };

        this.handleReviewEscape = (event) => {
          if (
            event.key === 'Escape' &&
            this.reviewOverlay.classList.contains(
              'active'
            )
          ) {
            this.closeReviewsDrawer();
          }
        };

        this.reviewTrigger.addEventListener(
          'click',
          this.openReviewsDrawer
        );

        this.reviewTrigger.addEventListener(
          'keydown',
          this.handleReviewTriggerKeydown
        );

        this.reviewOverlay.addEventListener(
          'click',
          this.handleReviewOverlayClick
        );

        document.addEventListener(
          'keydown',
          this.handleReviewEscape
        );

        if (this.reviewCloseButton) {
          this.reviewCloseButton.addEventListener(
            'click',
            this.closeReviewsDrawer
          );
        }
      }

      unbindReviewsDrawer() {
        if (
          this.reviewTrigger &&
          this.openReviewsDrawer
        ) {
          this.reviewTrigger.removeEventListener(
            'click',
            this.openReviewsDrawer
          );
        }

        if (
          this.reviewTrigger &&
          this.handleReviewTriggerKeydown
        ) {
          this.reviewTrigger.removeEventListener(
            'keydown',
            this.handleReviewTriggerKeydown
          );
        }

        if (
          this.reviewOverlay &&
          this.handleReviewOverlayClick
        ) {
          this.reviewOverlay.removeEventListener(
            'click',
            this.handleReviewOverlayClick
          );
        }

        if (this.handleReviewEscape) {
          document.removeEventListener(
            'keydown',
            this.handleReviewEscape
          );
        }

        if (
          this.reviewCloseButton &&
          this.closeReviewsDrawer
        ) {
          this.reviewCloseButton.removeEventListener(
            'click',
            this.closeReviewsDrawer
          );
        }
      }
    }

    customElements.define(
      'st-product-showcase-v1',
      STProductShowcaseV1
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-product-with-image-v1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('st-product-with-image-v1')) {
    class STProductWithImageV1 extends HTMLElement {
      connectedCallback() {
        this.initializeWhenReady();
      }

      disconnectedCallback() {
        if (
          this.swiper &&
          typeof this.swiper.destroy === 'function'
        ) {
          this.swiper.destroy(true, true);
        }
      }

      initializeWhenReady(attempt = 0) {
        if (this.dataset.initialized === 'true') return;

        if (typeof window.Swiper !== 'function') {
          if (attempt < 120) {
            window.setTimeout(
              () => this.initializeWhenReady(attempt + 1),
              50
            );
          }

          return;
        }

        this.initializeSwiper();
        this.bindVariantSwatches();

        this.dataset.initialized = 'true';
      }

      initializeSwiper() {
        const swiperElement = this.querySelector(
          '[data-product-swiper]'
        );

        if (!swiperElement) return;

        const previousButton = this.querySelector(
          '[data-swiper-previous]'
        );

        const nextButton = this.querySelector(
          '[data-swiper-next]'
        );

        const options = {
          slidesPerView: 1,
          speed: 500,
          loop: false,
          observer: true,
          observeParents: true,
          watchOverflow: true,
          on: {
            init: () => {
              this.syncMediaPlayback();
            },
            slideChangeTransitionEnd: () => {
              this.syncMediaPlayback();
            }
          }
        };

        if (previousButton && nextButton) {
          options.navigation = {
            prevEl: previousButton,
            nextEl: nextButton
          };
        }

        this.swiper = new window.Swiper(
          swiperElement,
          options
        );
      }

      syncMediaPlayback() {
        this.querySelectorAll('video').forEach((video) => {
          const slide = video.closest('.swiper-slide');

          const isActive =
            slide &&
            slide.classList.contains('swiper-slide-active');

          video.muted = true;

          if (isActive) {
            const playPromise = video.play();

            if (
              playPromise &&
              typeof playPromise.catch === 'function'
            ) {
              playPromise.catch(() => {});
            }
          } else {
            video.pause();
          }
        });

        this.querySelectorAll(
          '[data-external-video]'
        ).forEach((iframe) => {
          const slide = iframe.closest('.swiper-slide');

          const isActive =
            slide &&
            slide.classList.contains('swiper-slide-active');

          const source = iframe.dataset.src;

          if (
            isActive &&
            source &&
            !iframe.getAttribute('src')
          ) {
            iframe.setAttribute('src', source);
          } else if (
            !isActive &&
            iframe.getAttribute('src')
          ) {
            iframe.removeAttribute('src');
          }
        });
      }

      bindVariantSwatches() {
        const swatches = this.querySelectorAll(
          '[data-variant-swatch]'
        );

        if (!swatches.length) return;

        const variantInput = this.querySelector(
          '[data-variant-input]'
        );

        const variantNameElement = this.querySelector(
          '[data-variant-name]'
        );

        const priceElement = this.querySelector(
          '[data-st-product-price]'
        );

        const comparePriceElement = this.querySelector(
          '[data-st-product-compare-price]'
        );

        const addToCartButton = this.querySelector(
          '[data-atc-button]'
        );

        const productLinks = this.querySelectorAll(
          '[data-product-link]'
        );

        swatches.forEach((swatch) => {
          swatch.addEventListener('click', () => {
            const variantId = swatch.dataset.variantId;
            const variantName = swatch.dataset.variantName;
            const variantUrl = swatch.dataset.variantUrl;

            const available =
              swatch.dataset.available === 'true';

            const featuredMediaId =
              swatch.dataset.featuredMediaId;

            swatches.forEach((item) => {
              const active = item === swatch;

              item.classList.toggle(
                'is-active',
                active
              );

              item.setAttribute(
                'aria-pressed',
                active ? 'true' : 'false'
              );
            });

            if (variantInput && variantId) {
              variantInput.value = variantId;

              variantInput.dispatchEvent(
                new Event('change', {
                  bubbles: true
                })
              );
            }

            if (variantNameElement && variantName) {
              variantNameElement.textContent = variantName;
            }

            if (priceElement) {
              priceElement.textContent =
                swatch.dataset.price || '';
            }

            if (comparePriceElement) {
              const showComparePrice =
                swatch.dataset.showComparePrice === 'true';

              comparePriceElement.textContent =
                swatch.dataset.comparePrice || '';

              comparePriceElement.hidden =
                !showComparePrice;
            }

            if (addToCartButton) {
              addToCartButton.disabled = !available;

              if (available) {
                addToCartButton.setAttribute(
                  'aria-label',
                  'Add selected variant to cart'
                );
              } else {
                addToCartButton.setAttribute(
                  'aria-label',
                  'Selected variant is sold out'
                );
              }
            }

            if (variantUrl) {
              productLinks.forEach((link) => {
                link.setAttribute(
                  'href',
                  variantUrl
                );
              });
            }

            if (
              featuredMediaId &&
              this.swiper
            ) {
              const targetSlide = this.querySelector(
                `[data-media-id="${featuredMediaId}"]`
              );

              if (targetSlide) {
                const slides = Array.from(
                  this.querySelectorAll(
                    '.swiper-slide'
                  )
                );

                const targetIndex =
                  slides.indexOf(targetSlide);

                if (targetIndex >= 0) {
                  this.swiper.slideTo(targetIndex);
                }
              }
            }
          });
        });
      }
    }

    customElements.define(
      'st-product-with-image-v1',
      STProductWithImageV1
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-slider-v1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('st-slider-v1')) {
    class STSliderV1 extends HTMLElement {
      connectedCallback() {
        this.initializeWhenReady();
        this.initializeImagePopup();
      }

      disconnectedCallback() {
        this.destroySwiper();
        this.destroyImagePopup();
        this.unbindResponsiveReinitialization();
        this.clearSwiperRefreshTimers();
      }


      initializeImagePopup() {
        this.popup = this.querySelector('[data-st-image-popup]');
        this.popupImage = this.querySelector('[data-st-image-popup-image]');
        this.popupCloseButtons = Array.from(
          this.querySelectorAll('[data-st-image-popup-close]')
        );

        if (!this.popup || !this.popupImage) {
          return;
        }

        this.boundPopupDelegatedClick = (event) => {
          const trigger = event.target.closest('[data-st-image-popup-trigger]');

          if (!trigger || !this.contains(trigger)) {
            return;
          }

          event.preventDefault();
          this.openImagePopupFromTrigger(trigger);
        };

        this.boundClosePopup = this.closeImagePopup.bind(this);
        this.boundPopupKeydown = this.handlePopupKeydown.bind(this);

        this.addEventListener('click', this.boundPopupDelegatedClick);

        this.popupCloseButtons.forEach((button) => {
          button.addEventListener('click', this.boundClosePopup);
        });

        document.addEventListener('keydown', this.boundPopupKeydown);
      }

      openImagePopup(event) {
        const trigger = event.currentTarget;
        this.openImagePopupFromTrigger(trigger);
      }

      openImagePopupFromTrigger(trigger) {
        const imageUrl = trigger.dataset.popupImage;

        if (!imageUrl || !this.popup || !this.popupImage) return;

        this.lastPopupTrigger = trigger;
        this.popupImage.src = imageUrl;
        this.popupImage.alt = trigger.dataset.popupAlt || '';
        this.popup.classList.add('is-open');
        this.popup.setAttribute('aria-hidden', 'false');
        document.body.classList.add('st-slider-v1-popup-open');

        const closeButton = this.popup.querySelector('.st-slider-v1__lightbox-close');
        if (closeButton) closeButton.focus();
      }

      closeImagePopup() {
        if (!this.popup || !this.popup.classList.contains('is-open')) return;

        this.popup.classList.remove('is-open');
        this.popup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('st-slider-v1-popup-open');

        window.setTimeout(() => {
          if (this.popupImage) {
            this.popupImage.src = '';
            this.popupImage.alt = '';
          }
        }, 250);

        if (this.lastPopupTrigger) {
          this.lastPopupTrigger.focus();
        }
      }

      handlePopupKeydown(event) {
        if (event.key === 'Escape') {
          this.closeImagePopup();
        }
      }

      destroyImagePopup() {
        if (this.boundPopupDelegatedClick) {
          this.removeEventListener('click', this.boundPopupDelegatedClick);
        }

        if (this.popupCloseButtons && this.boundClosePopup) {
          this.popupCloseButtons.forEach((button) => {
            button.removeEventListener('click', this.boundClosePopup);
          });
        }

        if (this.boundPopupKeydown) {
          document.removeEventListener('keydown', this.boundPopupKeydown);
        }

        document.body.classList.remove('st-slider-v1-popup-open');
      }

      initializeWhenReady(attempt = 0) {
        if (this.dataset.initialized === 'true') return;

        if (typeof window.Swiper !== 'function') {
          if (attempt < 120) {
            window.setTimeout(
              () => this.initializeWhenReady(attempt + 1),
              50
            );
          }

          return;
        }

        this.initializeSwiper();
        this.bindResponsiveReinitialization();
        this.dataset.initialized = 'true';
      }

      getBooleanAttribute(name) {
        return this.dataset[name] === 'true';
      }

      removeLoopBufferSlides(slider) {
        if (!slider) return;

        slider
          .querySelectorAll('[data-st-loop-buffer="true"]')
          .forEach((slide) => slide.remove());
      }

      createMobileLoopBuffer(slider) {
        const wrapper = slider?.querySelector('.swiper-wrapper');

        if (!wrapper) return 0;

        this.removeLoopBufferSlides(slider);

        const originalSlides = Array.from(
          wrapper.querySelectorAll(
            ':scope > .swiper-slide:not([data-st-loop-buffer="true"])'
          )
        );

        const originalCount = originalSlides.length;

        if (originalCount < 2) {
          return originalCount;
        }

        const prependFragment = document.createDocumentFragment();
        const appendFragment = document.createDocumentFragment();

        originalSlides.forEach((slide, index) => {
          const prependClone = slide.cloneNode(true);
          const appendClone = slide.cloneNode(true);

          prependClone.dataset.stLoopBuffer = 'true';
          appendClone.dataset.stLoopBuffer = 'true';

          prependClone.dataset.stLoopRealIndex = String(index);
          appendClone.dataset.stLoopRealIndex = String(index);

          prependClone.removeAttribute('data-shopify-editor-block');
          appendClone.removeAttribute('data-shopify-editor-block');

          prependFragment.appendChild(prependClone);
          appendFragment.appendChild(appendClone);
        });

        wrapper.insertBefore(prependFragment, wrapper.firstChild);
        wrapper.appendChild(appendFragment);

        return originalCount;
      }

      normalizeBufferedLoopPosition() {
        if (
          !this.swiper ||
          this.swiper.destroyed ||
          !this.usingBufferedLoop ||
          !this.loopOriginalCount ||
          this.swiper.animating
        ) {
          return;
        }

        const count = this.loopOriginalCount;
        const index = this.swiper.activeIndex;

        if (index < count) {
          this.swiper.slideTo(index + count, 0, false);
          this.swiper.updateProgress();
          this.swiper.updateSlidesClasses();
          return;
        }

        if (index >= count * 2) {
          this.swiper.slideTo(index - count, 0, false);
          this.swiper.updateProgress();
          this.swiper.updateSlidesClasses();
        }
      }

      initializeSwiper() {
        const slider = this.querySelector(
          '[data-st-slider]'
        );

        if (!slider) return;

        const previousButton = this.querySelector(
          '[data-st-slider-previous]'
        );

        const nextButton = this.querySelector(
          '[data-st-slider-next]'
        );

        const pagination = this.querySelector(
          '[data-st-slider-pagination]'
        );

        this.removeLoopBufferSlides(slider);

        const slideCount = slider.querySelectorAll(
          '.swiper-wrapper > .swiper-slide'
        ).length;

        const mobileColumns =
          parseFloat(this.dataset.columnsMobile) || 1;

        const tabletColumns =
          parseFloat(this.dataset.columnsTablet) || 2;

        const desktopColumns =
          parseFloat(this.dataset.columnsDesktop) || 3;

        const showBothSidesMobile =
          this.getBooleanAttribute('showBothSidesMobile');

        const showBothSidesDesktop =
          this.getBooleanAttribute('showBothSidesDesktop');

        /*
         * Optional white separators.
         * When disabled, the original gap settings are used unchanged.
         * Tablet follows the desktop separator controls.
         */
        const whiteSeparatorsMobile =
          this.getBooleanAttribute('whiteSeparatorsMobile');

        const whiteSeparatorsDesktop =
          this.getBooleanAttribute('whiteSeparatorsDesktop');

        const originalMobileGap =
          parseInt(this.dataset.gapMobile, 10) || 0;

        const originalTabletGap =
          parseInt(this.dataset.gapTablet, 10) || 0;

        const originalDesktopGap =
          parseInt(this.dataset.gapDesktop, 10) || 0;

        const mobileSeparatorWidth =
          parseInt(this.dataset.separatorWidthMobile, 10) || 0;

        const desktopSeparatorWidth =
          parseInt(this.dataset.separatorWidthDesktop, 10) || 0;

        const mobileGap = whiteSeparatorsMobile
          ? mobileSeparatorWidth
          : originalMobileGap;

        const tabletGap = whiteSeparatorsDesktop
          ? desktopSeparatorWidth
          : originalTabletGap;

        const desktopGap = whiteSeparatorsDesktop
          ? desktopSeparatorWidth
          : originalDesktopGap;

        /*
         * A small fractional increase makes the neighbouring slides visible.
         * Centering then distributes that preview evenly on the left and right.
         */
        const mobileSlidesPerView = showBothSidesMobile
          ? mobileColumns + 0.15
          : mobileColumns;

        const tabletSlidesPerView = showBothSidesDesktop
          ? tabletColumns + 0.2
          : tabletColumns;

        const desktopSlidesPerView = showBothSidesDesktop
          ? desktopColumns + 0.2
          : desktopColumns;

        const viewportWidth = window.innerWidth;
        const currentSlidesPerView = viewportWidth >= 990
          ? desktopSlidesPerView
          : viewportWidth >= 750
            ? tabletSlidesPerView
            : mobileSlidesPerView;

        const currentShowBothSides = viewportWidth >= 750
          ? showBothSidesDesktop
          : showBothSidesMobile;

        /*
         * Loop is controlled independently by device.
         * Mobile applies below 750px.
         * Desktop applies from 750px upward, including tablet.
         */
        const requestedLoopMobile =
          this.getBooleanAttribute('loopMobile');

        const requestedLoopDesktop =
          this.getBooleanAttribute('loopDesktop');

        const requestedLoop =
          viewportWidth >= 750
            ? requestedLoopDesktop
            : requestedLoopMobile;

        /*
         * Mobile uses a buffered loop instead of Swiper's native loop.
         * With centered + fractional slides, native loop can expose a real
         * track edge while it rearranges a small slide set. The buffer keeps
         * a complete copy on both sides and silently recenters after motion.
         */
        const useBufferedMobileLoop =
          viewportWidth < 750 &&
          requestedLoopMobile &&
          slideCount > 1;

        this.usingBufferedLoop = useBufferedMobileLoop;
        this.loopOriginalCount = useBufferedMobileLoop
          ? this.createMobileLoopBuffer(slider)
          : 0;

        const enableNativeLoop =
          !useBufferedMobileLoop &&
          requestedLoop &&
          slideCount > Math.ceil(currentSlidesPerView);

        const initialSlide = useBufferedMobileLoop
          ? this.loopOriginalCount
          : currentShowBothSides && !enableNativeLoop && slideCount > 1
            ? 1
            : 0;

        const options = {
          slidesPerView: mobileSlidesPerView,
          spaceBetween: mobileGap,
          speed:
            parseInt(this.dataset.speed, 10) || 600,
          loop: enableNativeLoop,
          loopedSlides: enableNativeLoop ? slideCount : undefined,
          loopAdditionalSlides: enableNativeLoop ? slideCount : 0,
          loopPreventsSliding: false,
          initialSlide,
          centeredSlides:
            showBothSidesMobile ||
            this.getBooleanAttribute('centeredSlides'),
          grabCursor:
            this.getBooleanAttribute('grabCursor'),
          allowTouchMove:
            this.getBooleanAttribute('allowTouch'),
          watchOverflow: true,
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          keyboard: {
            enabled: true,
            onlyInViewport: true
          },
          on: {
            slideChangeTransitionEnd: () => {
              /*
               * Wait until Swiper has completely finished the visible motion.
               * Resetting on touchEnd causes a visible snap because touchEnd
               * fires before the slide transition has settled.
               */
              window.requestAnimationFrame(() => {
                this.normalizeBufferedLoopPosition();
              });
            }
          },
          breakpoints: {
            750: {
              slidesPerView: tabletSlidesPerView,
              centeredSlides:
                showBothSidesDesktop ||
                this.getBooleanAttribute('centeredSlides'),
              spaceBetween: tabletGap
            },
            990: {
              slidesPerView: desktopSlidesPerView,
              centeredSlides:
                showBothSidesDesktop ||
                this.getBooleanAttribute('centeredSlides'),
              spaceBetween: desktopGap
            }
          }
        };

        if (previousButton && nextButton) {
          options.navigation = {
            prevEl: previousButton,
            nextEl: nextButton
          };
        }

        if (pagination) {
          options.pagination = {
            el: pagination,
            clickable: true
          };
        }

        if (
          this.getBooleanAttribute('autoplay') &&
          slideCount > 1
        ) {
          options.autoplay = {
            delay:
              (parseInt(
                this.dataset.autoplayDelay,
                10
              ) || 4) * 1000,
            disableOnInteraction: false,
            pauseOnMouseEnter:
              this.getBooleanAttribute('pauseOnHover')
          };
        }

        this.swiper = new window.Swiper(
          slider,
          options
        );

        /*
         * centeredSlides + loop can briefly initialise against an edge
         * before the final slider width / images are measured. Normalise
         * the loop position immediately and again during scheduled refreshes
         * so both-side previews are present from the first stable paint.
         */
        if (this.usingBufferedLoop) {
          this.swiper.slideTo(this.loopOriginalCount, 0, false);
          this.normalizeBufferedLoopPosition();
        } else {
          this.stabilizeLoopPosition();
        }

        this.currentViewportGroup = this.getViewportGroup();
        this.scheduleSwiperRefresh(slider);
      }

      stabilizeLoopPosition() {
        if (
          !this.swiper ||
          this.swiper.destroyed ||
          !this.swiper.params.loop
        ) {
          return;
        }

        const realIndex = Number.isFinite(this.swiper.realIndex)
          ? this.swiper.realIndex
          : 0;

        /*
         * loopFix first creates/reorders the required loop slides.
         * slideToLoop then moves to the matching real slide rather than
         * leaving the active slide against either visual edge.
         */
        if (typeof this.swiper.loopFix === 'function') {
          this.swiper.loopFix();
        }

        if (typeof this.swiper.slideToLoop === 'function') {
          this.swiper.slideToLoop(realIndex, 0, false);
        }

        this.swiper.updateProgress();
        this.swiper.updateSlidesClasses();
      }

      getViewportGroup() {
        if (window.innerWidth >= 990) return 'desktop';
        if (window.innerWidth >= 750) return 'tablet';
        return 'mobile';
      }

      bindResponsiveReinitialization() {
        if (this.handleSliderResize) return;

        this.currentViewportGroup = this.getViewportGroup();

        this.handleSliderResize = () => {
          window.clearTimeout(this.sliderResizeTimer);

          this.sliderResizeTimer = window.setTimeout(() => {
            const nextViewportGroup = this.getViewportGroup();

            if (nextViewportGroup !== this.currentViewportGroup) {
              this.currentViewportGroup = nextViewportGroup;

              if (
                this.swiper &&
                typeof this.swiper.destroy === 'function'
              ) {
                this.swiper.destroy(true, true);
                this.swiper = null;
              }

              this.initializeSwiper();
              return;
            }

            this.refreshSwiperLayout();
          }, 120);
        };

        window.addEventListener('resize', this.handleSliderResize);
      }

      unbindResponsiveReinitialization() {
        if (this.handleSliderResize) {
          window.removeEventListener('resize', this.handleSliderResize);
          this.handleSliderResize = null;
        }

        if (this.sliderResizeTimer) {
          window.clearTimeout(this.sliderResizeTimer);
          this.sliderResizeTimer = null;
        }
      }

      scheduleSwiperRefresh(slider) {
        this.clearSwiperRefreshTimers();

        const refresh = () => {
          this.refreshSwiperLayout();

          if (this.usingBufferedLoop) {
            if (!this.swiper?.animating) {
              this.normalizeBufferedLoopPosition();
            }
          } else {
            this.stabilizeLoopPosition();
          }
        };

        requestAnimationFrame(() => {
          requestAnimationFrame(refresh);
        });

        this.swiperRefreshTimers = [
          window.setTimeout(refresh, 60),
          window.setTimeout(refresh, 160),
          window.setTimeout(refresh, 350),
          window.setTimeout(refresh, 700)
        ];

        slider.querySelectorAll('img').forEach((image) => {
          if (!image.complete) {
            image.addEventListener('load', refresh, { once: true });
          }
        });
      }

      clearSwiperRefreshTimers() {
        if (!this.swiperRefreshTimers) return;

        this.swiperRefreshTimers.forEach((timer) => {
          window.clearTimeout(timer);
        });

        this.swiperRefreshTimers = null;
      }

      refreshSwiperLayout() {
        if (!this.swiper || this.swiper.destroyed) return;

        this.swiper.updateSize();
        this.swiper.updateSlides();
        this.swiper.updateProgress();
        this.swiper.updateSlidesClasses();
        this.swiper.update();

        if (this.swiper.params.loop) {
          this.swiper.loopFix();
          this.stabilizeLoopPosition();
        }
      }

      destroySwiper() {
        if (
          this.swiper &&
          typeof this.swiper.destroy === 'function'
        ) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }

        this.clearSwiperRefreshTimers();

        const slider = this.querySelector('[data-st-slider]');
        this.removeLoopBufferSlides(slider);

        this.usingBufferedLoop = false;
        this.loopOriginalCount = 0;

        delete this.dataset.initialized;
      }
    }

    customElements.define(
      'st-slider-v1',
      STSliderV1
    );
  }

  } catch(e) { console.error(e); }
})();
})();
